/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Model_SizeInputs */

const en_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model Size`)
};

const fr_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille du modèle`)
};

const de_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modellgröße`)
};

const it_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione modello`)
};

const ru_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер модели`)
};

const es_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño del modelo`)
};

const zh_cn2_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型大小`)
};

const ja_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モデルサイズ`)
};

const hi_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मॉडल आकार`)
};

const pt_pt2_offline_sync_model_size = /** @type {(inputs: Offline_Sync_Model_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho do modelo`)
};

/**
* | output |
* | --- |
* | "Model Size" |
*
* @param {Offline_Sync_Model_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_model_size = /** @type {((inputs?: Offline_Sync_Model_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Model_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_model_size(inputs)
	if (locale === "de") return de_offline_sync_model_size(inputs)
	if (locale === "it") return it_offline_sync_model_size(inputs)
	if (locale === "ru") return ru_offline_sync_model_size(inputs)
	if (locale === "es") return es_offline_sync_model_size(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_model_size(inputs)
	if (locale === "ja") return ja_offline_sync_model_size(inputs)
	if (locale === "hi") return hi_offline_sync_model_size(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_model_size(inputs)
	return en_offline_sync_model_size(inputs)
});